export const mergeLabelValues = (
  labelsMap: Map<string, ReadonlySet<string>>,
  key: string,
  values: string[] | string
): Map<string, ReadonlySet<string>> => {
  const newValues = Array.isArray(values) ? values : [values];
  const existingValues = labelsMap.get(key) ?? new Set<string>();
  const updatedValues = new Set([...existingValues, ...newValues]);
  const updatedLabelsMap = new Map(labelsMap);
  updatedLabelsMap.set(key, updatedValues);
  return updatedLabelsMap;
};
